<ng-container *ngIf="svg">
  <svg [attr.viewBox]="svg.svgViewBox">
    <path [attr.d]="svg.svgPath" shape-rendering="geometricPrecision"></path>
  </svg>
</ng-container>
